import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "hideIcon", "use"];
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { useIsUngatedForBreeze } from '../../../hooks/useIsUngatedForBreeze';
import { getStyledAIButton } from './styledButtons/StyledAIBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CopilotBaseButton(_ref) {
  let {
      children,
      hideIcon = false,
      use = 'tertiary-light' // default to tertiary-light
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = use === BREEZE_SPECIAL ? undefined : use;
  const isUngatedForBreeze = useIsUngatedForBreeze();
  if (!isUngatedForBreeze) {
    return /*#__PURE__*/_jsxs(UIButton, Object.assign({}, uiButtonProps, {
      use: useOverride,
      children: [!hideIcon && /*#__PURE__*/_jsx(UIIcon, {
        name: "chatspot",
        size: '1.2em'
      }), children]
    }));
  }
  const CopilotButtonComponent = getStyledAIButton(use);
  return /*#__PURE__*/_jsxs(CopilotButtonComponent, Object.assign({}, uiButtonProps, {
    use: useOverride,
    children: [!hideIcon && /*#__PURE__*/_jsx(UIIcon, {
      name: "artificialIntelligence"
    }), children]
  }));
}